import React, {PureComponent, Fragment} from 'react';
import {Card, CardBody, CardText, CardTitle} from 'reactstrap';
import {Link, Redirect} from 'react-router-dom';

import CallToActions from '../../components/CallToActions/CallToActions.jsx';
import DefaultLayout from '../Layout/DefaultLayout.jsx';
import Header from '../../components/Header/Header.jsx';
import IllustratedDiv from '../../components/IllustratedDiv/IllustratedDiv.jsx';

import {generate} from '../../routes.js';

import './OurVision.scss';

import goal from './images/goal.jpg?size=600';
import header from './images/header.jpg?size=2000';
import method from './images/method.jpg?size=600';
import turnoverGraph from './images/turnover-graph.png?size=600';
import vision from './images/vision.jpg?size=600';

export default class OurVision extends PureComponent {
  render() {
    const title = "Twineeds | Notre vision du travail indépendant";
    const description = "Le monde du travail évolue: retrouvez notre vision sur l'évolution du monde de l'emploi et des rapports entre entreprises, consultants & freelance.";
    const figures = [
      {title: '2018', text: 'Lancement de Twineeds en France'},
      {title: '3', text: 'pays représentés'},
      {title: '3', text: 'métiers adressés'},
      {title: '400%', text: 'de croissance depuis notre création'},
    ];
    const headerBrief = <Fragment>
      <p>
        Twineeds est la plateforme de référence des travailleurs autonomes pour les <strong>Achats & la Supply Chain,
        les Ressources Humaines & la Finance</strong>.
      </p>
      <p>
        Les pigistes / indépendants peuvent maintenant travailler avec les plus grands groupes, <strong>de manière
        transparente et humaine</strong>.
      </p>
      <p>
        Les clients peuvent choisir le talent avec lequel ils vont collaborer, tout en <strong>laissant à Twineeds
        l'administratif et les impératifs juridiques</strong>.
      </p>
    </Fragment>;

    return (
      <DefaultLayout helmet={{title, description}} id="our-vision" showSidebarMenu={false}>
        <Header bgImg={header.src} brief={headerBrief} title="Proposer les bons mandats aux meilleurs spécialistes"/>

        <section className="container py-5">
          <IllustratedDiv imgSrc={vision.src} imgAlt={'Réunion dans un bureau entre profils qualifiés'}>
            <h2 className="mb-3">Notre vision</h2>
            <p>
              Alors qu'une <strong>transformation</strong> s'est déjà amorcée avec la crise Covid, nous sommes
              convaincus que le monde du travail va profondément changer dans les années à venir.
            </p>
            <p>
              Les meilleurs talents prennent conscience de leur <strong>valeur</strong> et deviennent des <strong>
              travailleurs autonomes</strong> pour se mettre au service de projets : ils se détachent ainsi du salariat
              traditionnel proposé par l'entreprise.
            </p>
          </IllustratedDiv>
          <IllustratedDiv imgSrc={goal.src} imgAlt={'Consultant indépendant conseille entreprise en regardant des documents'}>
            <h2 className="mb-3">Notre objectif</h2>
            <p>
              Parce-que la <strong>recherche de mandat</strong> peut être <strong>longue et complexe</strong>, notre
              objectif est d'aider les professionnels à trouver des opportunités afin de leur permettre de se concentrer
              sur une seule et unique activité : leur métier.
            </p>
            <p>
              Nous mettons également un point d'honneur à proposer des <strong>mandats correspondant aux attentes et
              profils de chacun</strong>, privilégiant ainsi la qualité à la quantité.
            </p>
          </IllustratedDiv>
          <IllustratedDiv imgSrc={method.src} imgAlt={'Consultante experimentée conseille une entreprise devant un PC'}>
            <h2 className="mb-3">Notre méthode</h2>
            <p>Notre approche phygitale s'appuie sur deux piliers distincts :</p>
            <ul>
              <li>
                Tous <strong>nos gestionnaires sont d'anciens professionnels des métiers adressés</strong> (RH, Finance &
                Achats). Ils connaissent ainsi parfaitement leur métier pour une meilleure adéquation entre le besoin
                client et les profils attendus, et vice-versa.
              </li>
              <li>
                Une plateforme digitale permettant aux travailleurs autonomes inscrits d'être <strong>alertés par courriel
                et message texte</strong> sur leur téléphone en cas de nouveaux mandats postés, et d'y <strong>candidater
                </strong>. Les mandats proposés peuvent d'ailleurs être pourvus en tant que travailleur autonome ou
                salarié.
              </li>
            </ul>
          </IllustratedDiv>
        </section>

        <div className="bg-light">
          <section className="container py-5">
            <IllustratedDiv imgSrc={turnoverGraph.src} imgAlt="Évolution et prévisions en millions du chiffre d'affaires de Twineeds">
              <h2 className="mb-3">Une méthode gagnante</h2>
              <p>
                Depuis son lancement en 2018 en France, Twineeds n'a cessé de se développer, affichant un chiffre
                d'affaires en constante augmentation.
              </p>
              <p>
                Témoins d'une méthode efficace, les entreprises faisant appel à nos services n'hésitent pas à nous
                renouveler leur confiance, pour une relation pérenne avec l'ensemble de nos clients.
              </p>
              <p>
                Face à la réussite de ce modèle, Twineeds décide en 2023 de s'exporter en s'implantant au Canada et plus
                particulièrement à Montréal, avec une représentation locale.
              </p>
            </IllustratedDiv>
          </section>
        </div>

        <div id="figures">
          <section className="container text-center py-5">
            <h2 className="mb-5">Twineeds en quelques chiffres</h2>
            <div className="row mb-5">
              {figures.map((element, index) => {
                return <div className="col-md-3 mb-2" key={index}>
                  <Card className="h-100">
                    <CardBody className="align-items-center">
                      <CardTitle className="mx-auto p-2">{element.title}</CardTitle>
                      <CardText>{element.text}</CardText>
                    </CardBody>
                  </Card>
                </div>;
              })}
            </div>
            <CallToActions>
              <Link className="btn btn-primary" to={generate({name: 'register-freelance'})}>S'inscrire</Link>
              <Link className="btn btn-white" to={generate({name: 'drop-need'})}>J'ai un besoin</Link>
            </CallToActions>
          </section>
        </div>
      </DefaultLayout>
    )
  }
}

export class About extends PureComponent {
  render() {
    return <Redirect to={generate({name: 'our-vision'})}/>;
  }
}
